<div class="flex flex-col gap-1">
  @if (neverFetched$ | async) {
    <div class="flex items-centerß">
      <em-icon name="warning_amber" class="text-warn-500 mr-1"></em-icon>
      {{ 'DATA_NEVER_FETCHED' | translate }}
    </div>
  }

  @if (lastFail$ | async; as lastFail) {
    <div class="flex items-center">
      <em-icon
        size="sm"
        name="error_outline"
        class="text-danger-500 mr-1"
      ></em-icon>
      <span class="capitalize">{{ 'SHARED_LABEL_FAILED' | translate }}:</span>
      <span class="font-bold ml-1">{{ formatRelative(lastFail) }}</span>
    </div>
    <ng-container [ngTemplateOutlet]="lastSuccess"></ng-container>
  } @else {
    @if (lastSuccess$ | async; as lasSuccess) {
      <div class="flex items-center">
        <em-icon size="sm" name="done" class="text-success-500 mr-1"></em-icon>
        <span class="capitalize">{{ 'SHARED_LABEL_SUCCESSFUL' | translate }}:</span>
        <span class="font-bold ml-1">{{ formatRelative(lasSuccess) }}</span>
      </div>
    }
  }
</div>

<ng-template #lastSuccess>
  @if (lastSuccess$ | async; as lasSuccess) {
    <div class="flex items-center">
      <em-icon size="sm" name="done" class="text-success-500 mr-1"></em-icon>
      <span class="capitalize">{{ 'SHARED_LABEL_SUCCESSFUL' | translate }}:</span>
      <span class="font-bold ml-1">{{ formatRelative(lasSuccess) }}</span>
    </div>
  }
</ng-template>
